// Copyright (c) 2021 Proto Labs, Inc. All Rights Reserved.
/* eslint-disable require-jsdoc */

import { HTTPMethods } from '../constants';

let bearer = '';

export function defaultHeaders(moredata: any = null) {
	const headers = new Headers();

	if (process.env.NODE_ENV === 'development' || bearer.length !== 0) {
		headers.append('Authorization', `Bearer ${bearer}`);
	}

	if (moredata !== null) {
		const keys = Object.keys(moredata);
		keys.forEach((key: string) => headers.append(key, moredata[key]));
	}
	return headers;
}

export async function updateAuthHeader() {
	if (window.tokenManager) {
		const token = await window.tokenManager.getAccessTokenAsync();

		if (token) {
			bearer = token;
		}
	}
}

export async function getFileTypes(): Promise<Response | null> {
	try {
		await updateAuthHeader();
		const url = `${window.TasBaseUrl}/api/configuration/filetypes?api-version=2022.3`;
		const response = await fetch(url, {
			method: HTTPMethods.Get,
			headers: defaultHeaders(),
		});
		return response;
	} catch (ex: any) {
		console.error(ex);
		return null;
	}
}

export default {
	getFileTypes,
	updateAuthHeader,
	defaultHeaders,
};
